import { useLocation } from 'react-router-dom'
import { usePageAlerts } from '@/hooks/usePageAlerts'
import Alerts from '@/components/Alerts'
import { useEffect } from 'react'
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'

export default function GlobalAlerts() {
  const { t } = useTranslation()
  const location = useLocation()
  const path = location.pathname

  const { alerts, error } = usePageAlerts(path)

  useEffect(() => {
    if (error) {
      toast.error(t('alerts.loadErrorTitle'), {
        description: error.message,
        duration: 4000,
        position: 'top-right',
      })
    }
  }, [error, t])

  return <Alerts key={path} alerts={alerts} />
}
